import { useScreenSize } from '@/hooks';
import QRCode from 'react-qr-code';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { Modal } from '@/components/common/dialog';
import { useConfigStore } from '@/stores';
import clsx from 'clsx';

interface ListTypeQrModalProps {
    qrUrl: string;
    isOpen: boolean;
    onClose: () => void;
}

const ListTypeQrModal = ({ qrUrl, isOpen, onClose }: ListTypeQrModalProps) => {
    const { t } = useTranslation();
    const { scaleHeightPixel } = useScreenSize();
    const screenMode = useConfigStore((state) => state.config.ui.screenMode);
    const isSplitMode = screenMode === 'split';

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            className={clsx(styles['qr-modal'], {
                [styles['qr-modal--halfmode']]: isSplitMode,
            })}
            scrollBarClassName="max-h-full! overflow-y-hidden!"
            wrapperClassName={
                isSplitMode
                    ? 'pb-[calc(212*var(--vh-unit))]!'
                    : 'items-center! pb-0!'
            }
            closeTabIndex={3}
            closeRegionOrder={3}
        >
            <div className={clsx(styles['qr-modal__container'])}>
                <div
                    id="list-type-qr-modal-title"
                    className={clsx(styles['qr-modal__title'], 'focus-border')}
                    aria-label={t('list_type.detail.qr_title')}
                    tabIndex={1}
                    data-interactive
                    data-modal-region
                    data-modal-region-order={1}
                >
                    {t('list_type.detail.qr_title')}
                </div>
                <div
                    className={clsx(styles['qr-modal__qr'], 'focus-border')}
                    aria-label={t('list_type.detail.tts.qr_code_img')}
                    tabIndex={2}
                    data-interactive
                    data-modal-region
                    data-modal-region-order={2}
                >
                    <QRCode value={qrUrl} size={scaleHeightPixel(186)} />
                </div>
            </div>
        </Modal>
    );
};

export default ListTypeQrModal;
